/* eslint-disable array-callback-return */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
// eslint-disable-next-line simple-import-sort/imports
import { ChangeEvent, FC, useMemo, useState } from 'react';
import { useStyles } from './style';
import { DragAndDrop } from '@orientaction/components';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { TextField, Grid, Typography, IconButton, CircularProgress } from '@material-ui/core';
import { useCategoryTest } from '@orientaction/hooks';
import { IcontentICategoryTest } from '@orientaction/types';
import { uploadImageAsync } from '@orientaction/utils';
import classnames from 'classnames';
import { useDropzone } from 'react-dropzone';
import { ReactComponent as UploadSimple } from '../../../Asset/svg/UploadSimple.svg';
import { ReactComponent as IconImage } from '../../../Asset/svg/icon-image.svg';
import { ReactComponent as TrashIcon } from '../../../Asset/svg/trash-2.svg';

const MAX_ICON_SIZE_BYTES = 100 * 1024 * 1024;

interface IContentOneCategory {
  id: number;
  required: boolean;
  name: string;
}

const getIconFileName = (category?: IcontentICategoryTest) => {
  if (category?.iconFileName) {
    return category.iconFileName;
  }

  if (!category?.icon) {
    return '';
  }

  const segments = category.icon.split('/');
  const lastSegment = segments[segments.length - 1] || 'icone';
  return decodeURIComponent(lastSegment.split('?')[0]);
};

const ContentOneCategory: FC<IContentOneCategory> = ({ id, name, required }) => {
  const classe = useStyles();
  const [uploadError, setUploadError] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  const { list, listTest, setList, setModal } = useCategoryTest();

  const category = useMemo(
    () => list.find((x: IcontentICategoryTest) => x && x.id === id),
    [list, id]
  );

  const updateCategory = (fields: Partial<IcontentICategoryTest>) => {
    const findIndex = list.findIndex((x: IcontentICategoryTest) => x && x?.id === id);

    if (findIndex === -1) {
      return;
    }

    const nextList = [...list];
    nextList[findIndex] = {
      ...nextList[findIndex],
      ...fields,
    };

    setList(nextList);
  };

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    updateCategory({ name: event.target.value });
  };

  const handleSubtitleChange = (event: ChangeEvent<HTMLInputElement>) => {
    updateCategory({ subtitle: event.target.value });
  };

  const handleDelete = () => {
    const object = {
      id_category: id as number,
      type: 'delete_category',
      open: true,
      title: 'Êtes-vous sûr de vouloir supprimer cette catégorie ',
      textCancel: 'Non',
      textValidate: 'Oui',
      noComfirmButton: false,
    };

    const contentListCurrent = listTest.filter((x: any) => x.category === id);

    if (contentListCurrent.length) {
      object.title = 'Cette catégorie contient encore des tests et ne peut pas être supprimée';
      object.noComfirmButton = true;
      object.textCancel = 'Ok';
    }

    setModal(object);
  };

  const handleRemoveIcon = () => {
    setUploadError('');
    updateCategory({ icon: '', iconFileName: '' });
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/jpeg,image/png,.jpg,.jpeg,.png',
    maxSize: MAX_ICON_SIZE_BYTES,
    multiple: false,
    disabled: isUploading,
    onDrop: async acceptedFiles => {
      setUploadError('');

      const file = acceptedFiles[0];
      if (!file) {
        return;
      }

      const uri = URL.createObjectURL(file);
      setIsUploading(true);

      try {
        const uploadedUrl = await uploadImageAsync(uri, 'category-icons');
        updateCategory({ icon: uploadedUrl, iconFileName: file.name });
      } catch (error) {
        setUploadError("Impossible d'importer l'icône. Veuillez réessayer.");
      } finally {
        setIsUploading(false);
      }
    },
    onDropRejected: () => {
      setUploadError('Format non accepté ou fichier supérieur à 100 Mo.');
    },
  });

  const iconFileName = getIconFileName(category);

  return (
    <div className={classe.root} data-cy="empty-category-block">
      <div className={classe.fieldWrapper}>
        <Typography className={classe.label}>Titre catégorie</Typography>

        <div className={classe.titleFieldRow}>
          <TextField
            variant="outlined"
            className={classe.formInput}
            onChange={handleNameChange}
            value={name || ''}
            placeholder="Renseignez le titre de la catégorie"
          />

          <IconButton
            className={classe.iconDelete}
            onClick={handleDelete}
            aria-label="Supprimer la catégorie">
            <DeleteForeverIcon />
          </IconButton>
        </div>

        {required && <Typography className={classe.require}>Champ obligatoire</Typography>}
      </div>

      <div className={classe.fieldWrapper}>
        <Typography className={classe.label}>Sous-titre</Typography>
        <TextField
          variant="outlined"
          className={classe.formInput}
          onChange={handleSubtitleChange}
          value={category?.subtitle || ''}
          placeholder="Texte sous titre"
        />
      </div>

      <div className={classe.fieldWrapper}>
        <Typography className={classe.iconUploadLabel}>Icone</Typography>

        {category?.icon ? (
          <div className={classe.iconUploadedBox}>
            <IconImage className={classe.iconUploadedFileIcon} aria-hidden={true} />
            <div className={classe.iconUploadedTexts}>
              <Typography className={classe.iconUploadedFileName}>{iconFileName}</Typography>
              <Typography className={classe.iconUploadedStatus}>Image importée</Typography>
            </div>
            <IconButton
              className={classe.iconUploadedDeleteBtn}
              onClick={handleRemoveIcon}
              aria-label="Supprimer l'icône">
              <TrashIcon className={classe.iconUploadedDeleteIcon} />
            </IconButton>
          </div>
        ) : (
          <>
            <div
              {...getRootProps({
                className: classnames(classe.iconUploadZone, {
                  [classe.iconUploadZoneDisabled]: isUploading,
                }),
              })}>
              <input {...getInputProps()} />
              <div className={classe.iconUploadZoneContent}>
                <div className={classe.iconUploadZoneIconWrap}>
                  {isUploading ? (
                    <CircularProgress size={24} />
                  ) : (
                    <UploadSimple className={classe.iconUploadZoneIcon} aria-hidden={true} />
                  )}
                </div>
                <Typography className={classe.iconUploadZoneTitle}>
                  Cliquez ou faites glisser ici pour importer
                </Typography>
                <Typography className={classe.iconUploadZoneHint}>
                  Formats acceptés : JPG, PNG (max. 100Mo)
                </Typography>
              </div>
            </div>
            {uploadError && <Typography className={classe.uploadError}>{uploadError}</Typography>}
          </>
        )}
      </div>

      <DragAndDrop key={name} id_category={id} />

      {!listTest.filter((x: any) => x.category === id).length && (
        <Grid
          container={true}
          alignItems="center"
          justifyContent="center"
          className={classe.delete}
          onClick={handleDelete}>
          <Grid item={true}>
            <DeleteForeverIcon />
          </Grid>
          <Grid item={true}>
            <Typography className={classe.textDelete}>Supprimer</Typography>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default ContentOneCategory;
